import { render, staticRenderFns } from "./goodsAnalyze.vue?vue&type=template&id=53f35229&scoped=true"
import script from "./goodsAnalyze.vue?vue&type=script&lang=js"
export * from "./goodsAnalyze.vue?vue&type=script&lang=js"
import style0 from "./goodsAnalyze.vue?vue&type=style&index=0&id=53f35229&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f35229",
  null
  
)

export default component.exports